import { useBrowseEnrichmentApi } from '@aibees/elephant/api/enrichment/use-browse-enrichment-api';
import { ENRICHMENT_READ_API_PREFIX } from '@aibees/elephant/constants';
import { HttpMethod } from '@aibees/shared/definition';
import { baseQueryClient, useBaseMutation } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';

export type UpdateEnrichmentRequest = {
  name: string;
};

export function useUpdateEnrichmentApi(id: string) {
  const workspaceId = useWorkspace()?.id ?? '';

  return useBaseMutation<UpdateEnrichmentRequest, unknown>(
    {
      url: `${ENRICHMENT_READ_API_PREFIX.replace(':wid', workspaceId).replace(
        ':id',
        id
      )}`,
      method: HttpMethod.patch,
    },
    {
      onSuccess: () => {
        baseQueryClient.invalidateQueries([useBrowseEnrichmentApi.name]);
        // update the enrichment requests filter options
        baseQueryClient.invalidateQueries({
          predicate: (query) => {
            const { queryKey } = query;
            return (
              (Array.isArray(queryKey) &&
                queryKey.includes('companies_enrichment_request_query')) ||
              queryKey.includes('people_enrichment_request_query')
            );
          },
        });
      },
    }
  );
}
